const CookieBannerOptions = {
  text:
    'We use cookies to offer you a better browsing experience, analyze site traffic, personalize content, and serve targeted advertisements. If you continue to use this site, you consent to our <a href="https://voximplant.com/legal/privacy" target="_blank">Privacy Policy</a> & <a href="https://voximplant.com/legal/cookies" target="_blank">Cookies Policy</a>',
  translates: {
    back: 'Back',
    title: '',
    parameters: 'Parameters',
    saveChanges: 'Save changes',
  },
  cookies: [
    {
      name: 'Strictly Necessary Cookies',
      required: true,
      gtm: 'strict_nec',
      checked: true,
      desc:
        "In order to enhance your internet experience and make the sharing of content easier, some of the pages on our website may contain tools or applications that are linked to third party social media service providers such as Facebook, Twitter, Google+ or other social media services/platforms. Through these tools or applications the social media service provider may set its own cookies on your device. We do not control these cookies and you should check the social media service provider's website for further details about how they use cookies.",
    },
    {
      name: 'Functionality Cookies',
      gtm: 'functionality_cookies',
      checked: true,
      desc:
        'These cookies are essential to make our site work. <a href="https://voximplant.com/" target="_blank">They enable you to move around</a> the site and use its features. Without these cookies, services that are necessary for you to be able to use our site, such as accessing secure areas, cannot be provided.',
    },
    {
      name: 'Analytics Cookies',
      gtm: 'analytics_cookies',
      checked: true,
      desc:
        'They enable you to move around the site and use its features. Without these cookies, services that are necessary for you to be able to use our site, such as accessing secure areas, cannot be provided.',
    },
    {
      name: 'Advertising Cookies',
      gtm: 'advertising_cookies',
      checked: true,
      desc:
        'These cookies are essential to make our site work. They enable you to move around the site and use its features. Without these cookies, services that are necessary for you to be able to use our site, such as accessing secure areas, cannot be provided.',
    },
  ],
  buttons: [
    {
      text: 'Accept required',
      type: 'acceptRequired',
      style: 'secondary',
    },
    {
      text: 'Accept all',
      type: 'accept',
    },
  ],
};

export default CookieBannerOptions;
